import { render, staticRenderFns } from "./ClicModal.vue?vue&type=template&id=7774084e&"
import script from "./ClicModal.vue?vue&type=script&lang=js&"
export * from "./ClicModal.vue?vue&type=script&lang=js&"
import style0 from "./ClicModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports